import { MouseEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from 'app/store';

import { setSidebarContent } from 'features/sidebar/sidebarSlice';

import { SidebarContentTypes } from 'constants/enums';

const useSidebarOpen = () => {
  const dispatch: AppDispatch = useDispatch();

  const openSidebar = useCallback(
    (contentId: SidebarContentTypes, id?: string | null) =>
      (e: MouseEvent<HTMLElement>) => {
        if (!id) return;
        e.stopPropagation();
        dispatch(setSidebarContent({ contentId, activeUserId: id }));
      },
    [dispatch]
  );

  return openSidebar;
};

export default useSidebarOpen;
